import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import GradeCard from "./GradeCard";

import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import { getStudents } from "../services/APIClient";

import "./ClassCard.css";

function DyslexiaScreenerClassCard(props) {
  let classDetails = props.classDetails;
  let name = classDetails.name;
  let gradeLevel = classDetails.grade_level;
  let classid = classDetails.id;

  let gradeLevel1 = classDetails.grade_level1;
  let gradeLevel2 = classDetails.grade_level2;
  let gradeLevel3 = classDetails.grade_level3;
  let trialClass = classDetails.trial_class;
  let specialEdClass = classDetails.specialed_class;
  let setClass = classDetails.set_class;

  let gradeLevelOptions = props.gradeLevelOptions;
  let teacherid = props.teacherid;
  let schoolid = props.schoolid;
  let countryId = props.countryId;

  let [studentsResponse, setStudentsResponse] = useState("");

  let teachers = props.teachers;

  useEffect(() => {
    getStudents(classid).then((response) => {
      setStudentsResponse(response);
    });
  }, [classid]);

  let students = [
    ...(studentsResponse.students || []),
    ...(studentsResponse.additionalStudents || []),
  ];

  return (
    <>
      <Col className="col-4">
        <Card
          className={`${
            trialClass
              ? "trial-card-detail"
              : specialEdClass
              ? "specialed-card-detail"
              : setClass
              ? "set-card-detail"
              : "card-detail"
          }`}
        >
          <Link
            className="link"
            to={`/dyslexiascreeneradmin`}
            state={{
              classDetails: { classDetails },
              teachers: { teachers },
              name: { name },
              gradeLevel: { gradeLevel },
              gradeLevelOptions: { gradeLevelOptions },
              teacherid: { teacherid },
              schoolid: { schoolid },
              countryId: { countryId }
            }}
          >
            <img
              src="./assets/imgs/Asset-class.webp"
              className="class-card-img"
            ></img>
            <div>
              <GradeCard
                gradeLevel={gradeLevel}
                gradeLevel1={gradeLevel1}
                gradeLevel2={gradeLevel2}
                gradeLevel3={gradeLevel3}
                trialClass={trialClass}
              />
              {students?.length !== undefined ? (
                <p className="class-card-text">
                  <img
                    src="./assets/imgs/child.png"
                    className="class-card-img"
                    alt="Student Image"
                  />
                  x {students.length}
                </p>
              ) : (
                <>
                  <br></br>
                  <p className="class-card-text">
                    Please add students to your class
                  </p>
                </>
              )}
            </div>
            <p
              className={`${
                trialClass ? "trial-class-card-text" : "class-card-text"
              }`}
            >
              {name}
            </p>
          </Link>
        </Card>
      </Col>
    </>
  );
}

export default DyslexiaScreenerClassCard;
